
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Step } from '@/models/Step'
import HomeIcon from 'vue-material-design-icons/Home.vue'
import HelpCircleIcon from 'vue-material-design-icons/HelpCircle.vue'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import strings from '@/assets/strings.json'
import { SmoothScrollOptions } from 'vue2-smooth-scroll'

@Component({
  components: {
    HomeIcon,
    HelpCircleIcon,
    ChevronLeftIcon
  }
})
export default class HeaderNavigator extends Vue {
  @Prop() private title!: string;
  @Prop() private subTitle?: string;
  @Prop() private onGoToClick!: Function;
  @Prop() private breadcrumbsSteps!: Array<Step>;
  @Prop() private directLink!: boolean

  private navigatorStrings = strings.Navigator;

  goToStep1 () {
    this.onGoToClick(0)
  }

  goToStep2 () {
    this.onGoToClick(1)
  }

  scrollDown () {
    const el = document.getElementById('how-it-work')
    const header = document.getElementById('header')
    const offset = header !== null ? header.offsetHeight + 100 : 100
    const options = {
      scrollTo: el,
      offset: -offset,
      duration: 500,
      easingFunction: (t: any) => t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
    } as SmoothScrollOptions
    this.$smoothScroll(options)
  }
}
